import React, { useEffect } from 'react';
import './TareasOperativas.scss';
import { Button, ScrollView } from 'devextreme-react';
import { newToast, ToolbarSimple } from '../../components';
import { useApiConfiguration } from '../../api/api.configuration';

export default () => {
  const { clearCache, getKeyClient } = useApiConfiguration();
  const [loading, setLoading] = React.useState(false);
  const [keyClient, setKeyClient] = React.useState('');
  const handleClear = async () => {
    setLoading(true);
    await clearCache();
    setLoading(false);
  };

  useEffect(() => {
    getKeyClient().then((res) => {
      setKeyClient(res);
    });
  }, []);

  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Tareas operativas'>
        <h5><strong>UID: </strong> {keyClient} </h5>
        <Button type='default' icon='clear' text='limpiar la cache del sistema' disabled={loading} className='btn-new' onClick={handleClear} />
      </ToolbarSimple>
    </ScrollView>
  );
};
